import React from "react";
import { MdSave } from "react-icons/md";

function ActionButtonsCargoCargo(props) {
  const {
    onClickCalculateAndSave = () => {},
    onClickCopyToMyCargo = () => {},
    calculatorData = {},
    isContractEstimate = false,
    isPrivate = false,
  } = props;

  const btnClass =
    "h-7 px-3 bg-[#313C4C] text-white hover:bg-[#252e3b] rounded-none text-[11px] font-medium flex items-center justify-center gap-1.5 whitespace-nowrap transition-all outline-none border-0 cursor-pointer shadow-2xs shrink-0";

  return (
    <div className="flex items-center justify-end gap-2 p-1">
      {isContractEstimate ? (
        calculatorData?.access === "private" ? (
          <button className={btnClass} onClick={onClickCalculateAndSave}>
            <MdSave size={14} />
            <span>Calculate & Save</span>
          </button>
        ) : (
          <button className={btnClass} onClick={onClickCopyToMyCargo}>
            <MdSave size={14} />
            <span>Copy to my Contract</span>
          </button>
        )
      ) : !isPrivate ? (
        <>
          <button className={btnClass} onClick={onClickCopyToMyCargo}>
            <MdSave size={14} />
            <span>COPY TO MY CARGO</span>
          </button>
          <button className={btnClass} onClick={onClickCalculateAndSave}>
            <MdSave size={14} />
            <span>CALCULATE & SAVE</span>
          </button>
        </>
      ) : null}
    </div>
  );
}

export default ActionButtonsCargoCargo;
